import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AuthService } from "../services/authService";

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userData) => AuthService.updateProfile(userData),
    onSuccess: (data) => {
      queryClient.setQueryData(["user"], data.user);
      // console.log("Perfil atualizado com sucesso!");
    },
    onError: (error) => {
      console.error("Erro ao atualizar perfil:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        headers: error.response?.headers,
      });
    },
  });
};
